import { HttpClient } from '@angular/common/http';
import { Component, OnInit, Input, ViewChild, ElementRef } from '@angular/core';
import { NbDialogRef } from '@nebular/theme';
import { NotificationsService } from 'angular2-notifications';
import * as moment from 'moment';
import { NgxSpinnerService } from 'ngx-spinner';
import { environment } from '../../../../../environments/environment';
import { TransactionInfo } from '../../../../shared/model/TransactionInfo';
import { EncriptyUtilService } from '../../../../shared/services/encripty-util.service';
import { HttpService } from '../../../../shared/services/http/http-client.service';

const API = environment.url_server;

@Component({
  selector: "ngx-modal-simulacao-venda-webtef",
  templateUrl: "./modal-simulacao-venda-webtef.component.html",
  styleUrls: ["./modal-simulacao-venda-webtef.component.scss"],
})
export class ModalSimulacaoVendaWebtefComponent implements OnInit {
  @Input()
  public transactionInfo: TransactionInfo;

  @ViewChild("card", null)
  private card: ElementRef;

  @ViewChild("emailInput", null)
  public emailInput: ElementRef;

  @ViewChild("cellInput", null)
  public cellInput: ElementRef;

  public dataHora: string;
  public valor: string;
  public qtdParcelas: string;
  public bandeira: string;
  public codAuth: string;
  public reciboUsuario: string;
  public enterpriseFederalId: string;

  constructor(
    protected ref: NbDialogRef<ModalSimulacaoVendaWebtefComponent>,
    private http: HttpService,
    private spinnerService: NgxSpinnerService,
    private encriptyService: EncriptyUtilService,
    public notificationService: NotificationsService
  ) {}

  ngOnInit() {
    this.enterpriseFederalId = this.encriptyService.decriptyBySecretKey(
      localStorage.getItem("bway-enterprise-federal-id")
    );

    const actualYear: number = new Date().getFullYear();
    this.card.nativeElement.ownerDocument.activeElement.blur();
    const transactionDate = moment(
      this.transactionInfo.data.concat("" + actualYear),
      "MMDDYYYY"
    ).toDate();
    const transactionHour = moment(
      this.transactionInfo.hora,
      "HHmmss"
    ).toDate();

    const data: string = moment(transactionDate).format("DD/MM/YYYY");
    const hora: string = moment(transactionHour).format("HH:mm:ss");
    this.dataHora = data.concat(" ").concat(hora);

    this.valor = String(this.transactionInfo.valor).replace(".", ",");
    this.qtdParcelas =
      this.transactionInfo.qtdParcelas == null ||
      this.transactionInfo.qtdParcelas === ""
        ? "1"
        : String(this.transactionInfo.qtdParcelas);

    this.bandeira = this.transactionInfo.bandeira;
    this.codAuth = this.transactionInfo.codAuth;
    this.reciboUsuario = this.transactionInfo.reciboUsuario;
  }

  public tipo: string = "email";
  selecionarTipo(tipo: string) {
    this.tipo = tipo;
  }

  enviar() {
    this.spinnerService.show();

    if (this.tipo === "email") {
      let message: string = this.reciboUsuario;

      let data: any = {
        remetente: "contato@topbank.com.br",
        destinatario: this.emailInput.nativeElement.value,
        assunto: "Comprovante de Pagamento",
        mensagem: message,
      };
      this.http.doPost(
        "/notification/sendEmail",
        data,
        (response) => {
          this.spinnerService.hide();
          this.notificationService.success("Comprovante enviado.");
          this.dismiss();
        },
        (error) => {
          this.spinnerService.hide();
          this.notificationService.success(
            "Não foi possível enviar comprovante."
          );
          this.dismiss();
        }
      );
    } else {
      let message: string = '';

      let ultimosDigitos: any = this.transactionInfo.numeroCartao
                                    .substring(this.transactionInfo.numeroCartao.length,
                                      this.transactionInfo.numeroCartao.length - 4);

      message = 'CNPJ/CPF: '.concat(this.enterpriseFederalId).concat('\n');
      message = message.concat('Cartão Final: ').concat(ultimosDigitos).concat('\n');
      message = message. concat('Valor: ').concat(this.valor).replace('.', ',')
                         .concat('\n');
      message = message.concat('Qtd Parcelas: '.concat(this.qtdParcelas)).concat('\n');

      let celular: string = String(this.cellInput.nativeElement.value)
        .replace("(", "")
        .replace(")", "")
        .replace(" ", "")
        .replace("-", "");
      let data: any = {
        celular: celular,
        msg: message,
      };

      this.http.doPost("/notification/sendSms",
        data,
        (response) => {
          this.spinnerService.hide();
          this.notificationService.success("Comprovante enviado.");
          this.dismiss();
        },
        (error) => {
          this.spinnerService.hide();
          this.notificationService.success(
            "Não foi possível enviar comprovante."
          );
          this.dismiss();
        }
      );
    }
  }

  dismiss() {
    this.ref.close();
  }
}
